/**
 * Displays a grid of images
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import i18n from '../../../shared/locales/no.json';

class MediaGrid extends PureComponent {
    static propTypes = {
        onShowMore: PropTypes.func,
    };

    state = { showMore: false };

    onShowMoreClick() {
        if (this.props.onShowMore) {
            this.props.onShowMore();
        }
        this.setState({ showMore: !this.state.showMore });
    }

    renderSingle() {
        return <div>{this.props.children}</div>;
    }

    renderTwoColumnChildren(children) {
        return React.Children.map(children, (child) => (
            <div className="grid__unit" key={`media-block-${child.key}`}>
                <div className="panel">{child}</div>
            </div>
        ));
    }

    renderDual() {
        return (
            <div className="grid t-grid grid--cols1to2">
                {this.renderTwoColumnChildren(this.props.children)}
            </div>
        );
    }

    renderFirstThree() {
        const child1 = React.Children.only(this.props.children[0]);
        const child2 = React.Children.only(this.props.children[1]);
        const child3 = React.Children.only(this.props.children[2]);

        return (
            <div className="grid t-grid grid--auto-height">
                <div className="grid__unit u-r-size2of3">
                    <div className="panel">{child1}</div>
                </div>
                <div className="grid__unit u-r-size1of3">
                    <div className="panel">{child2}</div>
                    <div className="panel">{child3}</div>
                </div>
            </div>
        );
    }

    renderShowMore() {
        if (
            React.Children.count(this.props.children) > 3 &&
            !this.state.showMore
        ) {
            return (
                <div className="u-mb32 u-mt16 u-text-center">
                    <button
                        className="button button--small"
                        onClick={this.onShowMoreClick.bind(this)}
                        type="button"
                    >
                        {i18n.images.showMore}
                    </button>
                </div>
            );
        }
    }

    renderRest() {
        if (this.state.showMore) {
            const children = this.props.children.slice(3);

            return (
                <div className="grid t-grid grid--cols1to2">
                    {this.renderTwoColumnChildren(children)}
                </div>
            );
        }
    }

    renderMoreThenTwo() {
        return (
            <div>
                {this.renderFirstThree()}
                {this.renderShowMore()}
                {this.renderRest()}
            </div>
        );
    }

    render() {
        const length = React.Children.count(this.props.children);

        if (length === 1) {
            return this.renderSingle();
        } else if (length === 2) {
            return this.renderDual();
        } else {
            return this.renderMoreThenTwo();
        }
    }
}

export default MediaGrid;
